const operations = ['simplify', 'factor', 'derive', 'integrate', 'zeroes', 'tangent', 'area', 'cos', 'sin', 'tan', 'arccos', 'arcsin', 'arctan', 'abs', 'log']

const operationReducer = (state = 'simplify', action) => operations.includes(action.payload) ? state = action.payload : state

export default operationReducer